var map = {
	"./common/footer.vue": "dd3b",
	"./common/header.vue": "d784d",
	"./common/headerSearch.vue": "34b0",
	"./common/longList.vue": "c125",
	"./common/longListArticleItem.vue": "59a4",
	"./common/longListComplaintItem.vue": "d529",
	"./home/banner.vue": "a319",
	"./home/sectionNews.vue": "2217",
	"./home/tabNews.vue": "34ff",
	"./user/ComplaintStatus.vue": "da45",
	"./user/UserStatus.vue": "1dc3",
	"./user/smallLayout.vue": "e1fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d78d";